import { memo } from "react";
import { useTranslation } from "react-i18next";
import { UI_ScreenStyles } from "../UI_ScreenStyles";
import { createBreadcrumbItems, commonBreadcrumbs } from "~/utils/breadcrumbUtils";

const UploadTaskScreen = () => {
  const { t } = useTranslation();
  return (
    <UI_ScreenStyles.UI_Wrapper>
      <UI_ScreenStyles.UI_Breadcrumb
        items={createBreadcrumbItems([
          commonBreadcrumbs.home,
          { title: 'Lượt tải lên', icon: commonBreadcrumbs.uploadTasks.icon }
        ])}
      />

      <UI_ScreenStyles.UI_Content_Wrapper>

      </UI_ScreenStyles.UI_Content_Wrapper>
    </UI_ScreenStyles.UI_Wrapper>
  )
}

export default memo(UploadTaskScreen);